import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorStoreWarehouseList = () => {
  const warehouseList = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/store-warehouse/list', payload, response => {
      if (response.status_code === 200) {
        callback(response.data)
      }
    })
  }, [])

  return { warehouseList }
}

export default InteractorStoreWarehouseList
